import type { TicketClassification } from '@yhelp/shared-types';
import { CLASSIFICATION_STYLES, classificationLabel } from '@/lib/ticket-meta';
import { cn } from '@yhelp/ui';

export function ClassificationBadge({
  classification,
  className,
}: {
  classification: TicketClassification;
  className?: string;
}) {
  const style = CLASSIFICATION_STYLES[classification];
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ring-1 ring-inset',
        style.bg,
        style.text,
        style.ring,
        className,
      )}
    >
      {classificationLabel(classification)}
    </span>
  );
}
